/* Sand of Scent - product detail behaviour.
   Guarded the same way as obtino-home.js: this file is requested by the
   product section, and a section can appear more than once in a template. */
(function () {
  'use strict';

  if (window.__sosPdpInit) return;
  window.__sosPdpInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init() {
    var root = document.querySelector('[data-sos-pdp]');
    if (!root) return;

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-sos-variants]').textContent);
    } catch (e) {
      variants = [];
    }

    var form = root.querySelector('.sos-pdp__form');
    var input = root.querySelector('[data-sos-variant-input]');
    var priceEl = root.querySelector('[data-sos-price]');
    var wasEl = root.querySelector('[data-sos-was]');
    var addBtn = root.querySelector('[data-sos-add-btn]');
    var addLabel = root.querySelector('[data-sos-add-label]');
    var titleEl = root.querySelector('[data-sos-variant-title]');
    var skuEl = root.querySelector('[data-sos-sku]');
    var stickyPrice = root.querySelector('[data-sos-sticky-price]');

    /* ---------- gallery ---------- */

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sos-thumb]'));
    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-sos-frame]'));

    function showMedia(mediaId) {
      var matched = false;
      frames.forEach(function (f) {
        var on = String(f.dataset.mediaId) === String(mediaId);
        f.classList.toggle('is-active', on);
        if (on) {
          f.removeAttribute('aria-hidden');
          matched = true;
        } else {
          f.setAttribute('aria-hidden', 'true');
        }
      });
      if (!matched) return;
      thumbs.forEach(function (t) {
        var on = String(t.dataset.mediaId) === String(mediaId);
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        showMedia(t.dataset.mediaId);
      });
    });

    /* ---------- variants ---------- */

    function selectedOptions() {
      var sets = root.querySelectorAll('[data-sos-option]');
      var out = [];
      Array.prototype.forEach.call(sets, function (fs) {
        var checked = fs.querySelector('input:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var hit = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) {
            hit = false;
            break;
          }
        }
        if (hit) return v;
      }
      return null;
    }

    /* A size that no variant offers is marked rather than removed, so the
       customer can see it exists. Only meaningful with 2+ option sets, but
       the single-option case falls out of the same code. */
    function markAvailability() {
      var sets = Array.prototype.slice.call(root.querySelectorAll('[data-sos-option]'));
      var current = selectedOptions();
      sets.forEach(function (fs, idx) {
        var radios = fs.querySelectorAll('input[type="radio"]');
        Array.prototype.forEach.call(radios, function (r) {
          var probe = current.slice();
          probe[idx] = r.value;
          var match = variants.filter(function (v) {
            for (var j = 0; j < probe.length; j++) {
              if (probe[j] !== null && v.options[j] !== probe[j]) return false;
            }
            return true;
          });
          var sellable = match.some(function (v) {
            return v.available;
          });
          var label = fs.querySelector('label[for="' + r.id + '"]');
          if (label) label.classList.toggle('is-unavailable', match.length > 0 && !sellable);
        });
      });
    }

    function apply() {
      var v = findVariant(selectedOptions());
      markAvailability();

      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Ikke tilgængelig';
        return;
      }

      if (input) input.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (wasEl) {
        if (v.compare) {
          wasEl.textContent = v.compare;
          wasEl.removeAttribute('hidden');
        } else {
          wasEl.setAttribute('hidden', '');
        }
      }
      if (titleEl) titleEl.textContent = v.title;
      if (skuEl) skuEl.textContent = v.sku || '—';
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Læg i kurv' : 'Udsolgt';
      var stockEl = root.querySelector('[data-sos-stock]');
      if (stockEl) {
        if (v.available) stockEl.removeAttribute('hidden');
        else stockEl.setAttribute('hidden', '');
      }

      var sb = root.querySelector('[data-sos-sticky-add]');
      if (sb) {
        sb.disabled = !v.available;
        sb.textContent = v.available ? 'Læg i kurv' : 'Udsolgt';
      }
      if (v.media) showMedia(v.media);

      // keep the URL shareable and the back button honest
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('sos-pdp__radio')) apply();
    });

    if (variants.length) markAvailability();

    /* ---------- quantity ---------- */

    var qtyField = root.querySelector('[data-sos-qty-field]');
    Array.prototype.forEach.call(root.querySelectorAll('[data-sos-qty]'), function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyField) return;
        var next = (parseInt(qtyField.value, 10) || 1) + parseInt(btn.dataset.sosQty, 10);
        qtyField.value = Math.max(1, next);
      });
    });

    /* ---------- add to cart ---------- */

    function refreshCount() {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-sos-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) el.removeAttribute('hidden');
            else el.setAttribute('hidden', '');
          });
        })
        .catch(function () {});
    }

    function submitAdd() {
      if (!form || !input) return;
      var qty = qtyField ? Math.max(1, parseInt(qtyField.value, 10) || 1) : 1;
      var original = addLabel ? addLabel.textContent : '';
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Lægger i kurv…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: input.value, quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (addLabel) addLabel.textContent = 'Lagt i kurv ✓';
          if (window.SOSCart) window.SOSCart.open();
          else refreshCount();
          setTimeout(function () {
            if (addLabel) addLabel.textContent = original || 'Læg i kurv';
            if (addBtn) addBtn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          // the network path failed; let the browser do a normal form post
          if (form) form.submit();
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitAdd();
      });
    }

    var stickyAdd = root.querySelector('[data-sos-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        submitAdd();
      });
    }

    /* ---------- sticky bar ---------- */

    var sticky = root.querySelector('[data-sos-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      document.body.classList.add('sos-pdp-has-sticky');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // show it only once the real button has scrolled past, never
            // before the customer has seen the real one
            var past = entry.boundingClientRect.top < 0;
            var on = !entry.isIntersecting && past;
            sticky.classList.toggle('is-on', on);
            // the bar is only offscreen, not removed, so its state has to be
            // mirrored for assistive tech and for keyboard tab order
            sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
            if (on) sticky.removeAttribute('inert');
            else sticky.setAttribute('inert', '');
          });
        },
        { rootMargin: '0px 0px -60px 0px' }
      );
      io.observe(addBtn);
    }
  }

  ready(init);
})();
